/** Origin only — no trailing slash. Use absoluteUrl() for page URLs. */
export const SITE_URL = "https://europinkescortservices.com";

export const absoluteUrl = (path = "/") => {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_URL}${normalized}`;
};
